import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = ({ children, requireAuth = true, require2FA = false, allowedRoles = [] }) => {
  const token = localStorage.getItem('token');

  if (!token && requireAuth) {
    return <Navigate to="/" replace />;
  }

  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decodedToken.exp <= currentTime) {
        localStorage.removeItem('token');
        return <Navigate to="/" state={{ sessionExpired: true }} replace />;
      }

      if (require2FA && !decodedToken.twoFactorVerified) {
        return <Navigate to="/auth/2fa" replace />;
      }

      if (allowedRoles.length > 0 && !allowedRoles.includes(decodedToken.role)) {
        if (decodedToken.role === 1) {
          return <Navigate to="/kl" replace />;
        } else if (decodedToken.role === 3) {
          return <Navigate to="/publikator" replace />;
        } else {
          return <Navigate to="/admin" replace />;
        }
      }

    } catch (error) {
      localStorage.removeItem('token');
      if (requireAuth) {
        return <Navigate to="/" replace />;
      }
    }
  }

  return children;
};

export default ProtectedRoute;